import { Vector3 } from 'three/src/math/Vector3';

export const SCENE = {
  scale: {
    adult: 1,
    teen: 1.15,
    child: 1.3,
    base: 0.04
  },

  camera: {
    fov: 50,
    near: 50,
    far: 150,

    position: new Vector3(0, 3, 65),

    lookAt: {
      oneRow: new Vector3(0, 5, -50),
      twoRows: new Vector3(0, 1, -50)
    }
  },

  lights: {
    ambient: {
      color: 0xffffff,
      intensity: 1.2
    },

    directional: {
      right: {
        color: 0xffffff,
        intensity: 1.0,
        position: new Vector3(100, 100, 100)
      },

      left: {
        color: 0xffffff,
        intensity: 1.0,
        position: new Vector3(-100, 100, 100)
      }
    }
  }
};

export const Positions = new Map([
  [1, [new Vector3(0.0, 10.0, -50.0)]],
  [2, [new Vector3(5.0, 10.0, -50.0), new Vector3(-5.0, 10.0, -54.0)]],
  [
    3,
    [
      new Vector3(0.0, 10.0, -50.0),
      new Vector3(-10.0, 10.0, -54.0),
      new Vector3(10.0, 10.0, -54.0)
    ]
  ],
  [
    4,
    [
      new Vector3(-5.0, 10.0, -50.0),
      new Vector3(-13.0, 10.0, -54.0),
      new Vector3(5.0, 10.0, -54.0),
      new Vector3(13.0, 10.0, -50.0)
    ]
  ],
  [
    5,
    [
      new Vector3(-5.0, 2.0, -50.0),
      new Vector3(-13.0, 2.0, -54.0),
      new Vector3(5.0, 2.0, -54.0),
      new Vector3(13.0, 2.0, -50.0),
      new Vector3(1.0, 15.0, -60.0)
    ]
  ],
  [
    6,
    [
      new Vector3(-5.0, 2.0, -50.0),
      new Vector3(-13.0, 2.0, -54.0),
      new Vector3(5.0, 2.0, -54.0),
      new Vector3(13.0, 2.0, -50.0),
      new Vector3(-7.5, 15.0, -62.0),
      new Vector3(2.5, 15.0, -60.0)
    ]
  ],
  [
    7,
    [
      new Vector3(-5.0, 2.0, -50.0),
      new Vector3(-13.0, 2.0, -54.0),
      new Vector3(5.0, 2.0, -54.0),
      new Vector3(13.0, 2.0, -50.0),
      new Vector3(-10.0, 15.0, -60.0),
      new Vector3(10.0, 15.0, -60.0),
      new Vector3(0.0, 15.0, -62.0)
    ]
  ],
  [
    8,
    [
      new Vector3(-5.0, 2.0, -50.0),
      new Vector3(-13.0, 2.0, -54.0),
      new Vector3(5.0, 2.0, -54.0),
      new Vector3(13.0, 2.0, -50.0),
      new Vector3(-15.0, 15.0, -60.0),
      new Vector3(15.0, 15.0, -62.0),
      new Vector3(5.0, 15.0, -60.0),
      new Vector3(-5.0, 15.0, -62.0)
    ]
  ]
]);
